import { Map as IMap } from 'immutable';

export default function (userPreferencesStore, settingsName) {
    if (userPreferencesStore instanceof IMap) {
        const userSettings = userPreferencesStore.get('userSettings');
        if (userSettings && userSettings.length) {
            const settings = userSettings.find(setting => setting.name === settingsName);
            return settings && settings.value;
        }
    }
    return null;
}
